/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelBookingNumberLookup.ts           *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/general/booking-number-lookup";

export class AutogenModelBookingNumberLookup<RowType extends ModelRow> extends Endpoint<RowType, RowBookingNumberLookupFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowBookingNumberLookup extends ModelRow<RowBookingNumberLookupFields> {
	constructor(values?: Partial<RowBookingNumberLookupFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowBookingNumberLookupFields {
	booking_no: string;
	company_id: string;
	container_id: string;
	container_status: string;
	cust_order_no: string;
	de_ramp: string;
	de_ramp_date: Date;
	drop_date: Date;
	drop_location_id: string;
	dropped: string;
	eir1_no: string;
	eir2_no: string;
	forwd_location_id: string;
	free_days: number;
	in_gate: Date;
	interchange: string;
	last_free_date: Date;
	ldport_location_id: string;
	load_date: Date;
	loading_completed: string;
	movement_id: string;
	notification_date: Date;
	origin_port: string;
	out_gate: Date;
	pick_up_date: Date;
	pick_up_no: string;
	port_of_discharge: string;
	rail_car: string;
	rail_carrier: string;
	ramp: string;
	ramp_date: Date;
	ramp_release: string;
	rdy_pickup_date: Date;
	release_number: string;
	rr_arrive_dest: Date;
	rr_clm_date: Date;
	rr_dest_ramp: string;
	rr_grounded: Date;
	rr_ingate: Date;
	rr_last_free_day: Date;
	rr_notification: Date;
	rr_outgate: Date;
	rr_release_no: string;
	rr_site: string;
	rr_status: string;
	rr_stcc: string;
	sail_date: Date;
	stack_location: string;
	stack_position: string;
	vessel: string;
	vessel_cutoff_date: Date;
	voyage: string;
}

